import React from 'react';
import CustomFilter from './CustomFilter'

class TournamentWatchFilters extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            showFilters: false,
            customFilter : {
                editMode : false,
                min : "0",
                max : "0",
                selectedColumn : '',
                isValid : true,
                errorText : ''
            },
            filters: {
                minsToStart: {
                    floatingLabelText: 'Time To Start',
                    value: 'lt 12',
                    disabled: false,
                    e2e:"timeToStart",
                    params: [
                        { value: 'lt 0.25', primaryText: 'Started' },
                        { value: 'lt 1', primaryText: 'less than 1 hour' },
                        { value: 'lt 2', primaryText: 'less than 2 hour' },
                        { value: 'lt 3', primaryText: 'less than 3 hour' },
                        { value: 'bt 3 6', primaryText: 'Between 3 to 6 hours' },
                        { value: 'bt 6 12', primaryText: 'Between 6 to 12' },
                        { value: 'lt 12', primaryText: 'less than 12 hour' }
                    ]
                },
                BuyIn: {
                    floatingLabelText: 'Buy In',
                    value: 'All',
                    disabled: false,
                    e2e:"buyIn",
                    params: [
                        { value: 'All', primaryText: 'All' },
                        { value: 'lt 11', primaryText: 'less than $11' },
                        { value: 'bt 11 55', primaryText: '$11.01 to $55' },
                        { value: 'bt 55.01 215', primaryText: '$55.01 to $215' },
                        { value: 'gt 14', primaryText: 'Over $14' }
                    ]
                },
                PrizePool: {
                    floatingLabelText: 'Prize Pool',
                    value: 'All',
                    disabled: false,
                    e2e:"prizePool",
                    params: [
                        { value: 'All', primaryText: 'All' },
                        { value: 'lt 500', primaryText: 'less then $500' },
                        { value: 'bt 500 4999.99', primaryText: '$500 to $4999.99' },
                        { value: 'bt 5000 49,999.99', primaryText: 'bt 5000 49,999.99' },
                        { value: 'gt 50000', primaryText: 'Over $50000' }
                    ]
                },
                Overlay: {
                    floatingLabelText: 'Overlay',
                    value: 'All',
                    disabled: false,
                    e2e:"overlay",
                    params: [
                        { value: 'All', primaryText: 'All' },
                        { value: 'lt 500', primaryText: 'bt 500 4999.99' },
                        { value: 'bt 500 4999.99', primaryText: '$500 to $4999.99' },
                        { value: 'bt 5000 49,999.99', primaryText: '$5000 to $49,999.99' },
                        { value: 'gt 50000', primaryText: 'Over $50000' },
                    ]
                },
                PredictedOverlay: {
                    floatingLabelText: 'Overlay Prediction',
                    value: 'All',
                    disabled: false,
                    e2e:"overlayPrediction",
                    params: [
                        { value: 'All', primaryText: 'All' },
                        { value: 'lt 1000', primaryText: 'less then $1000' },
                        { value: 'bt 1000 4999.99', primaryText: '$1000 to $4999.99' },
                        { value: 'bt 5000 10,999.99', primaryText: '$5000 to $10,999.99' },
                        { value: 'bt 10000 25,999.99', primaryText: '$10000 to $25,999.99' },
                        { value: 'bt 25000 100,999.99', primaryText: '$25000 to $100,999.99' },
                        { value: 'gt 100000', primaryText: 'Over $100000' }
                    ]
                },
                tournamentType: {
                    floatingLabelText: 'Tournament Type',
                    value: 'All',
                    disabled: false,
                    params: this.getTournamentType(props.tournamentTypes.length != 0 ? props.tournamentTypes : [])
                },
                flag: {
                    floatingLabelText: 'Flag',
                    value: 'All',
                    disabled: false,
                    params: this.getFlagPrams(props.flags.length != 0 ? props.flags : [])
                },
            }
        }
    }

    getTournamentType = ( tournamentTypes = [] ) => {
        return [
            { value: 'All', primaryText: 'All' },
            ...tournamentTypes.map(tournamentType => { return { value: tournamentType.name, primaryText: tournamentType.name } })
        ]
    }

    getFlagPrams = flags => {
        return [
            { value: 'All', primaryText: 'All' },
            ...flags.map(flag => { return { value: flag.name, primaryText: flag.name } })
        ]
    }

    filterChange = ( columnName ) => {
        return (event) => {
            const { value } = event.target;
            let { filters } = this.state;
            filters[columnName].value = value
            this.setState({ filters })
        }
    }

    onCustomFilterChange( columnName, value, disabled ) {
        let {filters} = this.state;
        filters[columnName] = {...filters[columnName], value, disabled};
        this.setState({ filters });
    }

    onCustomFilterExit = ( columnName ) => {
        let { filters } = this.state;
        filters[columnName].value = 'All';
        filters[columnName].disabled = false;
        this.setState({ filters });
    }

    onSearch = () => {
        let { filters } = this.state;
        let data = this.validateCustomFilter()
        if(data.status) {
            let {selectedColumn, min, max} = data.customFilter;
            let searchFilter = {};
            for (let filterName of Object.keys(filters)) searchFilter[filterName] = filters[filterName].value;
            searchFilter[ selectedColumn ] = this.generateCustomFilter(min, max);
            this.props.onSearch( searchFilter );
            this.setState({ showFilters: false })    
        } else {

            this.setState({customFilter : data.customFilter})
        }
        
    }
    
    validateCustomFilter = ()  => {
        let { customFilter } = this.state;
        let status = true;
        if( customFilter.editMode ) {
            if( parseFloat(customFilter.min) > parseFloat(customFilter.max) ) {
                customFilter.errorText = 'Min value cannot be greater than Max value';
                status = false;
            } else if( customFilter.min == '' && customFilter.max == '' ) {
                customFilter.errorText = 'Both min and max cannot be null';
                status = false;
            }
        }
        return { status, customFilter };
    }

    generateCustomFilter = (min, max) => {
        if(min == '') return `lt ${max}`
        else if(max == '') return `gt ${min}`
        else return `bt ${min} ${max}`
    }

    onFilter = () => this.setState({ showFilters: true });

    onCancel = () => this.setState({ showFilters: false });

    render() {
        const { showFilters, customFilter } = this.state;
        const searchButton = { e2e:'searchE2EButton' ,label: 'Search', action: this.onSearch, backgroundColor: '#ff9038' };
        const filterButton = { e2e:'filterE2EButton', label: 'Filter', action: this.onFilter, backgroundColor: '#ff9038' };
        const refreshButton = { e2e:'refreshE2EButton',label: 'Refresh', action: this.props.refresh, backgroundColor: '#ff9038' };
        const cancelButton = { e2e:'cancelE2EButton',label: 'Cancel', action: this.onCancel, backgroundColor: '#ff9038' };

        const {
            minsToStart,
            BuyIn,
            PrizePool,
            Overlay,
            PredictedOverlay,
            tournamentType,
            flag
        } = this.state.filters;

        return (
            <div style={{padding : '2%'}}>
                {showFilters ?
                    <div className='row'>
                        <NormalFilter e2e={minsToStart.e2e} filter={minsToStart} onChange={this.filterChange('minsToStart')} />
                        <NormalFilter e2e={BuyIn.e2e} filter={BuyIn} onChange={this.filterChange('BuyIn')} />
                        <NormalFilter e2e={PrizePool.e2e} filter={PrizePool} onChange={this.filterChange('PrizePool')} />
                        <NormalFilter e2e={Overlay.e2e} filter={Overlay} onChange={this.filterChange('Overlay')} />
                        <NormalFilter e2e={PredictedOverlay.e2e} filter={PredictedOverlay} onChange={this.filterChange('PredictedOverlay')} />
                        <NormalFilter e2e={tournamentType.e2e} filter={tournamentType} onChange={this.filterChange('tournamentType')} />
                        <NormalFilter filter={flag} onChange={this.filterChange('flag')} />
                        <CustomFilter 
                            filterParams={customFilter}  
                            onFilterChange ={params => {
                                // console.log({...customFilter,...params});
                                this.setState({customFilter : {...customFilter,...params}})
                            }}
                            onEsc={this.onCustomFilterExit} 
                        />
                    </div>
                    : null}
                <FilterButtons
                    buttonList={showFilters ? [searchButton, cancelButton] : [filterButton, refreshButton]}
                />
            </div>
        );
    }
}

const FilterButtons = props => {
    return (
        <div className='row'>
            {props.buttonList.map(button => {
                return (<div className='col-xs-6 col-sm-6 col-md-3'><button
                    type="button"
                    onClick={button.action}
                    className="btn btn-block"
                    style={{ 
                        background: button.backgroundColor,
                    }}
                    data-e2e= {button.e2e}
                >
                    {button.label}
                </button></div>)
            })}
        </div>
    )
}

const NormalFilter = props => {
    const { floatingLabelText, value, params } = props.filter;
    return (
        <div className="form-group col-xs-12 col-sm-6 col-md-3">
            <label style={{color : 'white'}} for="sel1">{floatingLabelText} :</label>
            <select data-e2e={props.e2e} value={value} onChange={props.onChange} className="form-control" style={{background : '#404040', color : "white"}} id="sel1">
                { params.map( param => <option value={param.value}>{param.primaryText}</option> ) }
            </select>
        </div>
    )
}

export default TournamentWatchFilters;


/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/TournamentWatchFilters.js
 **/